import { useAppStore } from '@/stores/AppStore'
import { WEB_APP_URL } from '@/stores/Constant'
import { AccumResponse, ImageBenefit, MembercardWebapp } from '@/type/MemberCard'
import axios from 'axios'

export function useMemberCardRepository() {
  const appStore = useAppStore()

  async function fetchMemberCardDetail(): Promise<MembercardWebapp> {
    try {
      const { data } = await axios.get(`${appStore.url}/api/v1/crm/line-app/p/member-card/`, {
        params: {
          channelId: appStore.channelId,
          l: appStore.userProfile.userId,
        },
      })
      return data
    } catch (error) {
      throw error
    }
  }

  async function fetchMemberBenefit(): Promise<ImageBenefit[]> {
    try {
      // backend เลือกรูปตามภาษาให้แล้ว ถ้าภาษานั้นไม่มีรูปจะ fallback จนจบที่รูปหลัก ไม่มีทางว่าง
      const { data } = await axios.get(`${WEB_APP_URL}/api/v1/benefit/customer/get-benefit`, {
        params: { lang: appStore.language },
      })
      return data
    } catch (error) {
      throw error
    }
  }

  async function fetchAccumList(uuid: string): Promise<AccumResponse> {
    try {
      const { data } = await axios.get(`${WEB_APP_URL}/api/v1/member_card/active-accum/${uuid}/`)
      return data
    } catch (error) {
      throw error
    }
  }

  async function fetchAccumNextPage(next: string): Promise<AccumResponse> {
    try {
      const proxyNext = next.replace('web-app', '/api/v1/member_card')
      const { data } = await axios.get(`${WEB_APP_URL}/${proxyNext}`)
      return data
    } catch (error) {
      throw error
    }
  }
  return {
    fetchMemberCardDetail,
    fetchMemberBenefit,
    fetchAccumList,
    fetchAccumNextPage,
  }
}
